export const TIMEZONES = new Set<string>([
  'US/Alaska',
  'US/Aleutian',
  'US/Arizona',
  'US/Central',
  'US/East-Indiana',
  'US/Eastern',
  'US/Hawaii',
  'US/Indiana-Starke',
  'US/Michigan',
  'US/Mountain',
  'US/Pacific',
  'US/Samoa',
  'Asia/Kolkata',
  'Europe/London',
  'Canada/Yukon',
  'Australia/North',
  'Australia/Hobart',
  'Australia/Eucla',
  'Australia/Lord_Howe',
  'Asia/Yangon',
  'Asia/Kathmandu',
  'NZ-CHAT',
]);

export const ALLOWED_TIMEZONES: Record<string, string> = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Kolkata': 'Asia/Kolkata',

  'America/New_York': 'US/Eastern',
  'America/Chicago': 'US/Central',
  'America/Denver': 'US/Mountain',
  'America/Los_Angeles': 'US/Pacific',
  'America/Anchorage': 'US/Alaska',
  'Pacific/Honolulu': 'US/Hawaii',
  'America/Phoenix': 'US/Arizona',
  'America/Adak': 'US/Aleutian',
  'Pacific/Pago_Pago': 'US/Samoa',

  'America/Whitehorse': 'Canada/Yukon',

  'Australia/Darwin': 'Australia/North',
  'Australia/Hobart': 'Australia/Hobart',
  'Australia/Eucla': 'Australia/Eucla',
  'Australia/Lord_Howe': 'Australia/Lord_Howe',

  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Yangon': 'Asia/Yangon',
  'Asia/Kathmandu': 'Asia/Kathmandu',

  'Europe/London': 'Europe/London',
  'Pacific/Chatham': 'NZ-CHAT',
};
